import React from 'react';

const Cabalgata = () => {
  return (
<div className="container mt-5 pt-3">
      {/* Section 1: Bootstrap Carousel */}
      <section>
      <div id="senderismoCarousel" className="carousel slide mb-5" data-bs-ride="carousel">
        <div className="carousel-indicators">
          <button type="button" data-bs-target="#senderismoCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#senderismoCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
        </div>
        
        <div className="carousel-inner rounded shadow">
          <div className="carousel-item active">
            <img src="/cabalgata.jpg" className="d-block w-100" alt="Eco Cabaña" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
          <div className="carousel-item">
            <img src="/cabalgata2.jpg" className="d-block w-100" alt="Sendero forestal" style={{ maxHeight: '600px', width: '100%', objectFit: 'contain' }} />
          </div>
        </div>
        
        <button className="carousel-control-prev" type="button" data-bs-target="#senderismoCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#senderismoCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
      </section>
      {/* Section 2: Title and Description */}
      <div className="row">
        <div className="col-12 text-center">
          <h1 className="display-4 text-success mb-3">Cabalgata</h1>
          <p className="lead mb-5 text-start">La cabalgata se ha diseñado para ser una experiencia tranquila y enriquecedora, permitiendo tanto a novatos como a jinetes experimentados conectarse con el entorno. Además, el recorrido se lleva a cabo en rutas que promueven la sostenibilidad y el respeto por el medio ambiente, pilares fundamentales de nuestro Ecohotel.
          <br/>Este evento único que busca ofrecer una experiencia inigualable, en la que los visitantes puedan disfrutar de la belleza natural que rodea el lugar a través de una cabalgata especial. Nuestros caballos son criados en el propio Ecohotel y los  huéspedes podrán explorar nuestros paisajes y disfrutar de la serenidad de la naturaleza en su máxima expresión. Al final del recorrido, los participantes podrán relajarse en nuestras instalaciones, disfrutar de la gastronomía local.</p>
        </div>
      </div>
    </div>
  );
};

export default Cabalgata;